import { useAppState } from "AppState";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import Title from "components/common/Title";

import React, { FunctionComponent, useContext, useEffect } from "react";
import { Col, Row } from "react-grid-system";
import { Routes } from "router";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import strings from "static/strings.js";
import { StyledButton, StyledContent, StyledHeader } from "./Welcome.style";

const Welcome: FunctionComponent = () => {
  const { goTo } = OnboardingContainer.useContainer();

  const handleOnDone = (event?: React.SyntheticEvent<HTMLButtonElement>) => {
    goTo({ route: Routes.Home, clearSession: true });
  };
  const { locationName } = useAppState();

  const shouldBeCentered = strings.kioskWelcome.length < 40;

  return (
    <PanelLayout
      title={locationName}
      titleSecondary="Thank You for Signing Up"
      centerContent
    >
      <div style={{ textAlign: "center", width: "95%", paddingTop: "10vh" }}>
        <Title style={shouldBeCentered ? {} : { textAlign: "left" }}>
          {strings.kioskWelcome}
        </Title>
        <StyledButton tertiary onClick={handleOnDone}>
          Done
        </StyledButton>
      </div>
    </PanelLayout>
  );
};

export default Welcome;



// WEBPACK FOOTER //
// ./src/screens/Kiosk/Welcome.tsx